import store from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Called when we change working hours start time
 * @timeInMinutes: new value for start time in minutes
 */
export default mutatorAction('setWorkingHoursStartTimeOption', function (timeInMinutes) {
    var optionState = store();
    optionState.workingHoursStartTime = timeInMinutes;
});
//# sourceMappingURL=setWorkingHoursStartTimeOption.js.map